// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--Rb1ph","icon":"_7a3fb80146--icon--agoE1","title":"_7a3fb80146--title--qg0Au"};